import { FC, Fragment } from "react";
import { Navigate, Outlet, useMatch } from "react-location";

import Details from "pages/ClosedOffers/components/OfferPreview";
import IdleTimerModal from "components/core/idle-timer-modal";
import Navbar from "./components/Navbar";
import NotificationBell from "./components/NotificationBell";
import Show from "../../components/core/show";
import Sidebar from "./components/Sidebar";
import TreatyPreview from "pages/AllTreaties/components/TreatyPreview";
import _ from "lodash";
import { useAppSelector } from "../../app/hooks";

type Props = {};

const Admin: FC<Props> = (props) => {
  const { access_token } = useAppSelector((state) => state.auth);
  const { selectedOffer } = useAppSelector((state) => state.offers);
  const { selectedTreaty } = useAppSelector((state) => state.treaty);
  const { pathname } = useMatch();

  if (!access_token) return <Navigate to={"/cpanel-login"} replace />;

  return (
    <Fragment>
      <div className="h-screen bg-gray-50 flex overflow-hidden">
        <Sidebar />
        <div className="flex-1 flex flex-col overflow-hidden">
          <Navbar />
          <div className="flex-1 flex items-stretch overflow-hidden">
            <Outlet />
            <Show if={!_.isEmpty(selectedOffer) && pathname === "/app/offers"}>
              <Details />
            </Show>
            <Show
              if={!_.isEmpty(selectedTreaty) && pathname === "/app/treaties"}
            >
              <TreatyPreview />
            </Show>
          </div>
        </div>
        <NotificationBell />
      </div>
      <IdleTimerModal />
    </Fragment>
  );
};

export default Admin;
